import React from "react";
import { clsx } from "clsx";

import Headline from "~components/shared/headline/Headline";
import { Media, MediaFormat } from "~components/shared/media/";
import OptionalEyebrow from "~components/shared/optional-eyebrow/OptionalEyebrow";
import { HEADLINE_SIZE } from "~types/lineup";
import { getNewsletter } from "~types/types";

import {
    type CardProps,
    PreviewErrorCard,
    CardSize,
    CARD_MEDIA_CONFIG,
} from "./Card";
import styles from "./Card.module.css";

export default function NewsletterCard({
    size = CardSize.SMALL,
    item,
    className,
    storyIndex,
    linkType = "Story",
    relatedLinkType,
    relatedIndex,
}: CardProps) {
    const { headline, url, media } = item;
    const newsletter = getNewsletter(item);

    if (!newsletter?.title || !url) {
        return <PreviewErrorCard itemType="newsletter" />;
    }

    const textLabel = newsletter?.defaultEyebrow
        ? `Newsletter: ${newsletter?.defaultEyebrow}`
        : `Newsletter: ${newsletter?.title}`;
    const updatedHeadline = newsletter?.defaultHeadline || headline;

    if (!media?.newsletterImage || !updatedHeadline) {
        return <PreviewErrorCard itemType="newsletter" />;
    }

    return (
        <a
            href={url}
            data-component="newsletter-card"
            data-link-type={linkType}
            data-link-index={storyIndex}
            data-link-related-type={relatedLinkType}
            data-link-related-index={relatedIndex}
            className={clsx(
                styles.card,
                styles[size],
                styles.newsletterCard,
                className
            )}
        >
            <Media
                source={item}
                priority={[MediaFormat.newsletterImage]}
                config={CARD_MEDIA_CONFIG}
            />
            <div className={styles.cardStoryBlock}>
                <OptionalEyebrow
                    textLabel={textLabel}
                    className={styles.optionalEyebrow}
                />
                <Headline
                    text={updatedHeadline}
                    isPhoenix
                    size={HEADLINE_SIZE.EXTRA_SMALL}
                />
            </div>
        </a>
    );
}
